export default "__VITE_ASSET__ChVjZR1Z__"